





































import Vue from 'vue';
// not going to refactor and type the VueSelect
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import VueSelect from 'vue-select';
import config from '../../../../config';
import 'vue-select/dist/vue-select.css';
import FetchHelper from '../../../helpers/OldFetchHelper';
import { ITeamSelectOption } from '../../../common/interfaces/shared.interface';
import { ITeamCustomerData } from '../../../common/interfaces/team.interface';
import { ICreateCustomerCartResponse } from '@/common/interfaces/cart.interface';

interface ITeamSelectComponent {
  OpenIndicator: { render: (arg: (el: string, options: { class: string }) => HTMLElement) => unknown };
  options: unknown[];
  value: string;
  $refs?: {
    vueSelect: typeof VueSelect & { clearSelection: () => unknown };
  };
}

export default Vue.extend({
  components: {
    'v-select': VueSelect,
  },
  data(): ITeamSelectComponent {
    return {
      OpenIndicator: {
        render: (createElement): HTMLElement => createElement(`span`, { class: `partner-select__icon` }),
      },
      options: [],
      value: ``,
    };
  },
  computed: {
    path(): string {
      return this.partner
        ? `${config.api.paths.teams.basepath}${config.api.paths.teams.paths.partners}`
        : `${config.api.paths.teams.basepath}${config.api.paths.teams.paths.customers}`;
    },
  },
  props: {
    infoText: {
      required: true,
      type: String,
    },
    partner: {
      required: true,
      type: Boolean,
    },
  },
  methods: {
    clear(): void {
      this.$refs.vueSelect.clearSelection();
    },
    emitInput(event: ICreateCustomerCartResponse): void {
      if(event) {
        this.$emit(`input`, event);
      }
    },
    onSearch(search: string, loading: (state: boolean) => void): void {
      loading(true);
      this.search(loading, search, this as unknown as Record<string, unknown>);
    },
    search: window._.debounce(async function searchForPartner(loading: (state: boolean) => void, searchString: string, vm: Record<string, unknown>): Promise<void> {
      if(!searchString || searchString.length < 3) {
        loading(false);
        return;
      }
      const response = await FetchHelper.post({
        body: { searchString },
        // ts can't infer the type of the outside this
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        path: this.path,
      });
      if(response.success) {
        // eslint-disable-next-line no-param-reassign
        vm.options = response.data.map((r: ITeamCustomerData): ITeamSelectOption => {
          return {
            customerNumber: r.customerNumber,
            label: `${r.name} - ${r.invoiceAddress?.zipCode} ${r.invoiceAddress?.city} ${r.invoiceAddress?.countryISO}`,
          };
        });
      }
      loading(false);
    }, 350),
  },
});
